import { IconifyIcon } from 'iconify-icon'

export const IconVideoPlay: IconifyIcon = {
	body:
		'<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path fill="currentColor" d="M15.25 2h-6.5A6.76 6.76 0 0 0 2 8.75v6.5A6.76 6.76 0 0 0 8.75 22h6.5A6.76 6.76 0 0 0 22 15.25v-6.5A6.76 6.76 0 0 0 15.25 2m1 10.39a1.5 1.5 0 0 1-.44.56l-4.51 3.5a1.46 1.46 0 0 1-.78.32h-.16a1.6 1.6 0 0 1-.66-.16a1.4 1.4 0 0 1-.62-.56a1.53 1.53 0 0 1-.24-.8V8.73a1.64 1.64 0 0 1 .22-.78a1.53 1.53 0 0 1 .58-.55a1.6 1.6 0 0 1 .8-.19c.273.022.536.108.77.25l4.51 3c.197.139.361.32.48.53a1.45 1.45 0 0 1 0 1.38z"/></svg>',
	width: 20,
	height: 20,
}
export default IconVideoPlay
